import type {IPartner} from "~/data/types";

export const PARTNERS = [
    {
        name: 'MONT TECH',
        inn: "",
        logo: "/images/partners/mont.svg",
        link: "//www.monttech.kz"
    }
] as IPartner[];
